import { FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Control, Controller, FieldErrors, FieldPath, FieldValues } from 'react-hook-form'

import { Staff } from '@/core/models/staff.model'

export type PerformerSelectProps<TFieldValues extends FieldValues = FieldValues> = {
  staffList: Staff[]
  control: Control<TFieldValues>
  errors: FieldErrors<TFieldValues>
  name?: FieldPath<TFieldValues>
}

export function PerformerSelect<TFieldValues extends FieldValues = FieldValues>({
  staffList,
  control,
  errors,
  name = 'performedById' as FieldPath<TFieldValues>,
}: PerformerSelectProps<TFieldValues>) {
  const { t } = useTranslation()

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: t('common.validation.required', { defaultValue: 'This field is required' }) }}
      render={({ field }) => (
        <FormControl fullWidth required error={!!errors[name]}>
          <InputLabel>{t('medicalAct.record.performedBy', { defaultValue: 'Performed By' })}</InputLabel>
          <Select {...field} label={t('medicalAct.record.performedBy', { defaultValue: 'Performed By' })}>
            {staffList.map((staff) => (
              <MenuItem key={staff._id} value={staff._id}>
                {staff.userInfo?.name} {staff.userInfo?.surname}
                {staff.status && ` - ${staff.status}`}
              </MenuItem>
            ))}
          </Select>
          {errors[name] && (
            <Typography variant="caption" color="error">
              {errors[name]?.message as string}
            </Typography>
          )}
        </FormControl>
      )}
    />
  )
}
